export async function callClaude(input: string, context: any, apiKey: string, signal?: AbortSignal): Promise<string> {
  try {
    const res = await fetch('https://api.anthropic.com/v1/messages', {
      method: 'POST',
      headers: {
        'x-api-key': apiKey,
        'anthropic-version': '2023-06-01',
        'Content-Type': 'application/json',
        'anthropic-dangerous-direct-browser-access': 'true'
      },
      signal,
      body: JSON.stringify({
        model: context.modelOverride || 'claude-3-haiku-20240307',
        max_tokens: 1024,
        system: context.systemPrompt || `You are OS Bot, a real estate CRM assistant. Personality: ${context.personality || 'professional'}.`,
        messages: [
          ...(context.messages || []).map((m: any) => ({
            role: m.role === 'ai' ? 'assistant' : m.role,
            content: m.content
          })),
          { role: 'user', content: input }
        ],
        temperature: 0.2
      })
    });
    
    if (!res.ok) {
      const errorBody = await res.text();
      console.error(`[Claude Provider] HTTP Error ${res.status}:`, errorBody);
      try {
        const errorData = JSON.parse(errorBody);
        throw new Error(errorData.error?.message || `Claude API Error: ${res.status}`);
      } catch (e) {
        throw new Error(`Claude API Error: ${res.status}`);
      }
    }

    const data = await res.json();
    return data.content?.[0]?.text || '';
  } catch (error: any) {
    console.error('[Claude Provider] Error:', error);
    throw error;
  }
}
